import React, { useState } from 'react';

import { ConfirmationForm } from './confirmation_form';
import { Modal } from '@buildoutinc/blueprint-react/ui/Modal';
import { PhoneForm } from './phone_form';

import type { PhoneEnrollment, UserProfilePaths } from 'components/users/types';

export type EnrollmentStep = 'number' | 'code';

interface Props {
  codeExpiresAt: string | null;
  initialStep: EnrollmentStep;
  paths: UserProfilePaths;
  personalNumber: string | null;
  onChange: (enrollment: PhoneEnrollment) => void;
  onClose: () => void;
}

export function PhoneEnrollmentDialog({
  codeExpiresAt,
  initialStep,
  paths,
  personalNumber,
  onChange,
  onClose,
}: Props) {
  const [step, setStep] = useState<EnrollmentStep>(initialStep);
  // Held here rather than in PhoneForm because the confirmation step names the number it texted.
  const [number, setNumber] = useState<string>(personalNumber || '');

  function handleEnrolled(enrollment: PhoneEnrollment) {
    onChange(enrollment);
    setStep('code');
  }

  return (
    <Modal open onClose={onClose}>
      <Modal.Content>
        {step === 'number' ? (
          <PhoneForm
            number={number}
            path={paths.phoneEnrollment}
            onChange={setNumber}
            onClose={onClose}
            onEnrolled={handleEnrolled}
          />
        ) : (
          <ConfirmationForm
            codeExpiresAt={codeExpiresAt}
            number={number}
            path={paths.confirmPhoneEnrollment}
            onClose={onClose}
            onConfirmed={onChange}
            onRestart={() => setStep('number')}
          />
        )}
      </Modal.Content>
    </Modal>
  );
}
